import { observer } from 'mobx-react-lite'
import { useAuthStore } from '../AuthStore'
import AuthSignIn from './AuthSignIn'
import CenterFullScreen from 'reusable/mui/utilities/CenterFullScreen'
import AuthSignInNewPasswordRequired from './new-password-required/AuthSignInNewPasswordRequired'
import { useMemo } from 'react'

export default observer(function AuthSignInFlow() {
   const authStore = useAuthStore()

   const content = useMemo(() => {
      switch (authStore.status) {
         case 'sign in':
         case 'verify with mfa code':
            return <AuthSignIn />
         case 'new password required':
            return <AuthSignInNewPasswordRequired />
         default:
            return null
      }
   }, [authStore.status])

   return <CenterFullScreen>
      {content}
   </CenterFullScreen>
})
